module.exports = __webpack_public_path__ + "static/media/undraw_financial_data_es63_green.56050143.svg";